import React from 'react';
import {useSelector} from 'react-redux';
import {View, Image, Text, ImageBackground} from 'react-native';
const signInImage = require('src/Images/signInImage.png');

const EventLeaderboardCompact = ({
  groupsOverride,
  backgroundStyle = {},
  title = 'Leaderboard',
  body,
}) => {
  const groups = groupsOverride || useSelector((state) => state.event?.groups);

  let place = 0;
  let previousHigherScore = 0;

  const rankedGroups =
    !!groups &&
    groups
      .slice()
      ?.filter((newGroup) => {
        return !newGroup.deleted;
      })
      ?.sort((a, b) => {
        const aScore = a?.score > 0 ? 1 * a?.score : 0;
        const bScore = b?.score > 0 ? 1 * b?.score : 0;
        if (aScore < bScore) {
          return 1;
        }
        if (bScore < aScore) {
          return -1;
        }
        return 0;
      })
      ?.map?.((group) => {
        const newGroup = {...group};

        let photoUrl = newGroup?.groupPhoto;
        if (previousHigherScore != newGroup.score) {
          previousHigherScore = group.score;
          place = place + 1;
          newGroup.place = place;
        }
        if (!photoUrl && group.players) {
          // let firstPlayer = Object.values(group.players)[0];
          // newGroup.photoUrl = firstPlayer.photoUrl;
        } else {
          newGroup.photoUrl = newGroup?.groupPhoto;
        }
        if (place == 1) {
          newGroup.backgroundColor = global?.color?.yellow;
        } else if (place == 2) {
          newGroup.backgroundColor = global?.color?.blue;
        } else if (place == 3) {
          newGroup.backgroundColor = global?.color?.teal;
        }
        return newGroup;
      });

  console.log('EventLeaderboardCompact', {rankedGroups});
  return (
    <ImageBackground
      source={require('src/Images/Rank/leaderboard.jpg')}
      resizeMode={'stretch'}
      style={{
        flex: 1,
        marginTop: 20,
        alignItems: 'center',
        ...backgroundStyle,
      }}>
      <Image
        source={require('src/Images/happyTrophy.png')}
        style={{height: 40, width: 60, marginTop: 20}}
      />
      <Text
        style={{
          color: 'white',
          fontSize: 18,
          fontFamily: global.font.circularBold,
        }}>
        {title}
      </Text>
      {!!body && (
        <Text
          style={{
            color: 'white',
            fontSize: 16,
            fontFamily: global.font.circularBold,
            textAlign: 'center',
            padding: 10,
          }}>
          {body}
        </Text>
      )}
      <View style={{display: 'flex', flexDirection: 'row', marginTop: 20}}>
        <PlacedTeam rank={2} team={rankedGroups?.[1]} />
        <PlacedTeam rank={1} team={rankedGroups?.[0]} />
        <PlacedTeam rank={3} team={rankedGroups?.[2]} />
      </View>
    </ImageBackground>
  );
};

// note rank is sometimes different then place
// if all teams have same score
export const PlacedTeam = ({rank, team}) => {
  if (!team) {
    return <View style={{flex: 1}}></View>;
  }

  const isMiddle = rank === 1;

  const photoUrl = team?.photoUrl || team?.photo_url;
  return (
    <View style={{flex: 1, display: 'flex', alignItems: 'center'}}>
      <View
        style={{
          borderRadius: isMiddle ? 46 : 33,
          overflow: 'hidden',
          borderColor: 'white',
          borderWidth: 3,
        }}>
        <Image
          source={
            photoUrl ? {uri: team?.photoUrl || team?.photo_url} : signInImage
          }
          style={{width: isMiddle ? 80 : 60, height: isMiddle ? 80 : 60}}
        />
      </View>
      <View
        style={{
          top: -10,
          backgroundColor: team?.backgroundColor,
          padding: 3,
          borderRadius: 12,
          width: 24,
          height: 24,
        }}>
        <Text
          style={{
            textAlign: 'center',
            color: global.color?.gray3,
            fontFamily: global.font?.circularBold,
            fontSize: 14,
          }}>
          {team.place || rank}
        </Text>
      </View>
      <Text
        style={{
          textAlign: 'center',
          color: global.color?.white,
          fontFamily: global.font?.circularBold,
          fontSize: 14,
          lineHeight: 14,
        }}>
        {team.teamName || team.first_name}
      </Text>
      <Text
        style={{
          textAlign: 'center',
          color: global.color?.white,
          fontFamily: global.font?.circularBold,
          fontSize: 10,
        }}>
        {team.score || team.points} pts
      </Text>
    </View>
  );
};

export default EventLeaderboardCompact;
